export const useSettings = defineStore("settings", () => {
  const menubarBottom = ref(false);
  return {
    menubarBottom,
  };
});
